import { render, staticRenderFns } from "./WalletCardTextField.vue?vue&type=template&id=05e452cb&"
import script from "./WalletCardTextField.vue?vue&type=script&lang=js&"
export * from "./WalletCardTextField.vue?vue&type=script&lang=js&"
import style0 from "./WalletCardTextField.vue?vue&type=style&index=0&id=05e452cb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports